<script setup lang="ts">
import { computed, useSlots } from 'vue';

import {
  PhxPicture as PhxsgCorePicture,
  type PhxPictureProps as PhxsgCorePictureProps,
} from '@sg-core/src/View/Components/Atoms/Picture';

defineProps<PhxsgCorePictureProps>();

const slots = useSlots();

const hasVariantSlot = computed(() => Boolean(slots.variant));
</script>

<template>
  <PhxsgCorePicture v-bind="$props">
    <template v-if="hasVariantSlot" #variant>
      <slot name="variant" />
    </template>
  </PhxsgCorePicture>
</template>
